import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Bull } from '../../../models/bull';

export default function BullLine(props: { row: Bull }) {
	const { row } = props;

	return (
		<TableRow sx={{ height: 45 }}>
			<TableCell>{row.number}</TableCell>
		</TableRow>
	);
}
